module.exports = __webpack_public_path__ + "static/media/kanban.b18d9179.png";